import { Autocomplete, Box, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Country } from '../../data';
import { IFormInput } from '../../useHomeContact';

import { useSxStyles } from './useStyles';

type Props = {
  form: UseFormReturn<IFormInput>;
  countryList: Country[];
};

export const HomeContactEditMode = (props: Props) => {
  const {
    form: { control },
    countryList,
  } = props;

  const commonFieldProps: Partial<TextFieldProps> = {
    size: 'small',
    fullWidth: true,
  };

  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  return (
    <Box sx={sxStyles.fieldSet}>
      <Controller
        control={control}
        name={'fEmpPhoneHome'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpPhoneHome')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={'fEmpEmailHome'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpEmailHome')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />

      <Controller
        control={control}
        name={'fEmpStreetAddress1'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpStreetAddress1')}
              error={!!error?.message}
              helperText={error?.message}
              required={true}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={'fEmpStreetAddress2'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpStreetAddress2')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={'fEmpPostalCode'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpPostalCode')}
              error={!!error?.message}
              helperText={error?.message}
              required={true}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={'fEmpCity'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpCity')}
              error={!!error?.message}
              helperText={error?.message}
              required={true}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={'fEmpState'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpState')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />

      <Controller
        control={control}
        name="fEmpCountry"
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Autocomplete
            fullWidth={true}
            size={'small'}
            options={countryList}
            getOptionLabel={(c) => c.name}
            onChange={(_event, value) => {
              onChange(value?.code || '');
            }}
            value={countryList.find((op) => op.code === value) || null}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('fEmpCountry')}
                required={true}
                error={!!error?.message}
                helperText={error?.message}
              />
            )}
          />
        )}
      />
    </Box>
  );
};
